/**
 * Returns a same-origin relative path safe for post-login redirect, or null.
 * Blocks open redirects (external hosts, protocol-relative, etc.).
 */
export function getSafeInternalPath(raw) {
  if (raw == null || typeof raw !== 'string') return null;
  let path;
  try {
    path = decodeURIComponent(raw.trim());
  } catch {
    return null;
  }
  if (!path.startsWith('/')) return null;
  if (path.startsWith('//')) return null;
  if (path.includes('://')) return null;
  if (path.includes('\\')) return null;
  if (path.includes('@')) return null;
  if (/[\u0000-\u001F\u007F]/.test(path)) return null;

  const allowed =
    path === '/dashboard' ||
    path.startsWith('/orders/') ||
    path.startsWith('/delivering');
  if (!allowed) return null;
  if (path.length > 512) return null;
  return path;
}
